import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = ["href"];
const _hoisted_2 = {
    style: { "width": "0", "height": "0", "position": "absolute" },
    "aria-hidden": "true",
    focusable: "false"
};
const _hoisted_3 = { class: "progress-content" };
const _hoisted_4 = { class: "saved" };
const _hoisted_5 = { class: "goal" };
const _hoisted_6 = {
    key: 0,
    class: "mt-2"
};
import { ref, computed, onMounted } from 'vue';
import BarArrowButton from './BarArrowButton.vue';
import { useDarkMode } from '@/composables/useDarkMode';
export default /*@__PURE__*/ _defineComponent({
    __name: 'GoalInfoPanel',
    props: {
        title: {},
        href: { default: '' },
        goal: {},
        saved: {},
        instalment: { default: 0 },
        formatter: {},
        small: { type: Boolean, default: false }
    },
    setup(__props) {
        const { isDarkMode } = useDarkMode();
        const props = __props;
        const animatedProgress = ref(0);
        const goalProgressPercent = computed(() => {
            return Math.min(100, Math.max(0, Math.round((props.saved / props.goal) * 100)));
        });
        function animateProgress(targetValue) {
            animatedProgress.value = 0;
            const increment = targetValue / 50;
            const interval = setInterval(() => {
                if (animatedProgress.value < targetValue) {
                    animatedProgress.value += increment;
                }
                else {
                    animatedProgress.value = targetValue;
                    clearInterval(interval);
                }
            }, 10);
        }
        onMounted(() => {
            animateProgress(goalProgressPercent.value);
        });
        return (_ctx, _cache) => {
            const _component_v_progress_circular = _resolveComponent("v-progress-circular");
            const _component_v_col = _resolveComponent("v-col");
            const _component_v_row = _resolveComponent("v-row");
            return (_openBlock(), _createBlock(BarArrowButton, {
                large: true,
                title: _ctx.title,
                href: _ctx.href
            }, {
                default: _withCtx(() => [
                    _createElementVNode("a", {
                        href: _ctx.href,
                        class: "slotLink"
                    }, [
                        _createElementVNode("div", {
                            class: _normalizeClass(["barArrowButtonSlotContent", { dark: _unref(isDarkMode) }])
                        }, [
                            (_ctx.goal && _ctx.goal > 0)
                                ? (_openBlock(), _createBlock(_component_v_row, {
                                    key: 0,
                                    class: "mt-1"
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_v_col, { class: "progressCol" }, {
                                            default: _withCtx(() => [
                                                (_openBlock(), _createElementBlock("svg", _hoisted_2, _cache[0] || (_cache[0] = [
                                                    _createElementVNode("linearGradient", {
                                                        id: "progress-gradient",
                                                        gradientTransform: "rotate(215.75)"
                                                    }, [
                                                        _createElementVNode("stop", { offset: "3.1%" }),
                                                        _createElementVNode("stop", { offset: "95.08%" })
                                                    ], -1)
                                                ]))),
                                                _createVNode(_component_v_progress_circular, {
                                                    width: "4",
                                                    "model-value": goalProgressPercent.value,
                                                    size: _ctx.small ? 100 : 120,
                                                    "bg-color": "#f7faf7",
                                                    color: "#61678D",
                                                    class: "progress-circle"
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createElementVNode("div", _hoisted_3, [
                                                            _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.formatter.format(_ctx.saved, false, false)), 1),
                                                            _cache[1] || (_cache[1] = _createElementVNode("div", { calss: "centered" }, "of", -1)),
                                                            _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.formatter.format(_ctx.goal, false, false)), 1)
                                                        ])
                                                    ]),
                                                    _: 1
                                                }, 8, ["model-value", "size"]),
                                                (_ctx.instalment)
                                                    ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.formatter.format(_ctx.instalment)) + " a month", 1))
                                                    : _createCommentVNode("", true)
                                            ]),
                                            _: 1
                                        })
                                    ]),
                                    _: 1
                                }))
                                : _createCommentVNode("", true)
                        ], 2)
                    ], 8, _hoisted_1)
                ]),
                _: 1
            }, 8, ["title", "href"]));
        };
    }
});
